import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setBreadcrumb } from '../actions/breadcrumb'

import { SHIPPING, UNKNOWN } from '../assets/constant'
import { isEmpty, stringEmpty, pad } from '../assets/utils'

class SummaryMode extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.onClick = this.onClick.bind(this)

  }

  onClick() {
    if (!this.props.shipback.charged) {
      this.props.setBreadcrumb(SHIPPING)
    }
  }

  getDropoff() {
    for (var i = 0; i < this.props.shipback.quotes.length;i++) {
      var quote = this.props.shipback.quotes[i]
      if (quote.mode == "dropoff" && quote.dropoff_points) {
        for (var j = 0 ; j < quote.dropoff_points.length; j++) {
          var dropoff = quote.dropoff_points[j]
          if (dropoff.id == this.props.shipback.dropoff_code) {
            return dropoff
          }
        }
      }
    }
  }

  getModeDetails() {
    switch(this.props.mode) {
      case "pickup":
        if (!isEmpty(this.props.shipback.pickup_datetime) && !isEmpty(this.props.shipback.pickup_duration)) {
          var dateAndTime = this.props.shipback.pickup_datetime.split(' ')
          var time = dateAndTime[1].split(':')
          var date = new Date()
          date.setHours(Number(time[0]) + Number(this.props.shipback.pickup_duration / 60))
          date.setMinutes(Number(time[1] + Number(this.props.shipback.pickup_duration % 60)))

          return (
            <span>
              {I18n.t('layouts.summary.mode.pickup.date')}: {dateAndTime[0]}
              <br/>
              {I18n.t('layouts.summary.mode.pickup.slot')}: {time[0]}:{time[1]} - {pad(date.getHours())}:{pad(date.getMinutes())}
            </span>
          )
        }
      case "dropoff":
        if (!isEmpty(this.props.shipback.dropoff_code)) {
          var dropoff = this.getDropoff()
          if (dropoff) {
            return (
              <span>
                {I18n.t('layouts.summary.mode.dropoff.name')}: {dropoff.name}
                <br/>
                {I18n.t('layouts.summary.mode.dropoff.address')}:  {stringEmpty(dropoff.line1)} <br/> {stringEmpty(dropoff.zipcode) + " " + stringEmpty(dropoff.city)}
              </span>
            )
          }
        }
      default:
        return (
          <span></span>
        )
    }
  }

  render() {
    if (!isEmpty(this.props.shipback) && this.props.mode != UNKNOWN) {
      var image = modes[this.props.mode]
      var value = 'modes.' + this.props.mode
      return (
        <div className="mode">
          <a href="#" onClick={this.onClick}>
            <h3>{I18n.t('layouts.summary.mode.title')}</h3>
            <p>
              <img src={image} alt={this.props.mode} />
              <span className="value">{I18n.t(value)}</span>
            </p>
          </a>
          {this.getModeDetails()}
          <hr className="separator" />
        </div>
      )
    } else {
      return (<div></div>)
    }
  }
}

const mapStateToProps = state => ({
  mode: state.shipback.mode,
  shipback: state.shipback
})

const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SummaryMode)


// WEBPACK FOOTER //
// ./app/javascript/components/components/SummaryMode.jsx